const blogPosts = [
  {
    id: 1,
    slug: "quvae-website-redesign",
    title: "QUVAE Website Redesign",
    excerpt:
      "Complete redesign of the QUVAE website to improve user experience, modernize the interface, and create a mobile-friendly platform with better content structure and visual clarity.",
    category: "UX / UI",
    author: "HanaToria Team",
    date: "March 5, 2026",
    readTime: "8 min read",
    cardImage: {
      src: "/LatestBuzz/quvae/hero.png",
      alt: "QUVAE case study thumbnail",
    },
    client: "QUVAE",
    service: "UX UI Design",
    duration: "~2 Months",
    tools: "Figma, Ps, Ai",
    heroImage: {
      src: "/LatestBuzz/quvae/hero.png",
      alt: "QUVAE hero mockup",
    },
    contents: [
      { id: "overview", label: "Overview" },
      { id: "about-client", label: "About Client" },
      { id: "the-challenge", label: "The Challenge" },
      { id: "our-approach", label: "Our Approach" },
      { id: "visual-design", label: "Visual Design" },
      { id: "revisions", label: "Revisions" },
      { id: "final-outcome", label: "Final Outcome" },
    ],
    overview: {
      heading: "Overview",
      image: {
        src: "/LatestBuzz/quvae/overview.png",
        alt: "QUVAE website overview composition",
      },
    },
    aboutClient:
      "QUVAE is a research and publication-focused organization that shares knowledge, insights, and academic content. Their website serves as a platform to present research materials, publications, and organizational information to a wide range of users including researchers, students, and professionals.",
    challenge: {
      intro:
        "When QUVAE approached us, their existing website had several usability and design issues. The interface looked outdated, the navigation structure was unclear, and the website was not optimized for mobile devices. Users found it difficult to navigate through the content, and the overall engagement was low due to poor visual hierarchy and content structuring.",
      screenshot: {
        src: "/LatestBuzz/quvae/old-website.png",
        alt: "QUVAE old website screenshot",
      },
      mainCard: { title: "Outdated UI design", icon: "desktop" },
      issueCards: [
        { title: "Poor user experience", icon: "user" },
        { title: "Not mobile responsive", icon: "phone" },
        { title: "Low user engagement", icon: "users" },
        { title: "Unclear content structure", icon: "layout" },
      ],
    },
    approach: [
      "Research & Industry Understanding",
      "Competitor Analysis",
      "User Flow & Information Architecture",
      "Wireframing & Prototyping",
      "Style Guide & Visual Direction",
      "UI Design",
      "Revisions & Improvements",
      "Prototype & Usability Testing",
    ],
    featureBlocks: [
      {
        title: "Wireframes & Structure",
        description:
          "Focused on clear content hierarchy, structured layout, better navigation flow, proper spacing, and mobile-friendly planning to drastically improve the UX foundation.",
        image: {
          src: "/LatestBuzz/quvae/wireframes.png",
          alt: "QUVAE wireframes and structure",
        },
      },
      {
        title: "Visual Design & UI System",
        description:
          "We established a typography system, color palette, button styles, card components, grid system, and visual guidelines to ensure consistency across all responsive breakpoints.",
        image: {
          src: "/LatestBuzz/quvae/visual-system.png",
          alt: "QUVAE visual design and UI system",
        },
      },
    ],
    revision: {
      title: "Revision & Feedback",
      description:
        "During the design process, the client requested multiple revisions, especially in the style guide and color theme. We explored different visual directions and updated the design according to the client's preferences while maintaining usability and visual clarity.",
      image: {
        src: "/LatestBuzz/quvae/revisions.png",
        alt: "QUVAE revision and feedback screens",
      },
    },
    outcome: {
      description: "The redesigned website resulted in:",
      images: [
        { src: "/LatestBuzz/quvae/outcome-1.png", alt: "QUVAE final outcome composition" },
        { src: "/LatestBuzz/quvae/outcome-2.png", alt: "QUVAE final outcome detailed views" },
      ],
    },
    testimonial: {
      headline: "High-quality work delivered through a seamless, collaborative process.",
      quote:
        "We worked with Hanatoria on the graphical video and website UI development, and the experience was positive. They were very cooperative and open to making changes, even across multiple rounds of revisions. The pricing felt fair, and the overall quality of the work met our expectations.",
      name: "Name",
      role: "Member, Quvae",
      rating: 5,
      logo: {
        src: "/LatestBuzz/quvae/logo.png",
        alt: "QUVAE logo",
      },
    },
  },
  {
    id: 2,
    slug: "jornie-brand-visual-design",
    title: "JORNIE Brand Visual Design",
    excerpt:
      "Creating a premium and simple visual identity for JORNIE, a footwear brand, to establish a strong and consistent brand presence across digital and print platforms.",
    category: "Branding",
    author: "HanaToria Team",
    date: "March 12, 2026",
    readTime: "7 min read",
    cardImage: {
      src: "/LatestBuzz/jornie/hero.png",
      alt: "JORNIE case study thumbnail",
    },
    client: "Jornie",
    service: "Graphic Design",
    deliverables: "Social Media Creatives",
    tools: "Ps, Ai",
    heroImage: {
      src: "/LatestBuzz/jornie/hero.png",
      alt: "JORNIE hero photography",
    },
    heroBackground: "linear-gradient(135deg, #d8dde2 0%, #e3e7eb 50%, #d8dde2 100%)",
    contents: [
      { id: "overview", label: "Overview" },
      { id: "about-client", label: "About Client" },
      { id: "the-requirement", label: "The Requirement" },
      { id: "the-challenge", label: "The Challenge" },
      { id: "our-approach", label: "Our Approach" },
      { id: "design-approach", label: "Design Approach" },
      { id: "final-outcome", label: "Final Outcome" },
    ],
    overview: {
      heading: "Overview",
      image: {
        src: "/LatestBuzz/jornie/overview.png",
        alt: "JORNIE poster series overview",
      },
    },
    aboutClient:
      "JORNIE is a footwear manufacturer focused on creating stylish and quality footwear products. As a new brand entering the market, they needed a strong visual identity to position themselves as a premium brand and attract customers through modern and clean design communication.",
    requirement: {
      intro:
        "Since JORNIE was a new brand, the client approached us to develop premium and simple visual designs that could be used across multiple platforms including social media, print materials, advertisements, website, and events.",
      deliverables: [
        { title: "Print", icon: "print" },
        { title: "Instagram", icon: "instagram" },
        { title: "Web Banners", icon: "browser" },
        { title: "Ads", icon: "ads" },
      ],
    },
    challenge: {
      intro:
        "The main challenge in this project was to create a premium-looking design style for a new brand. Since the brand was new, there was no existing visual identity, so we had to build the visual language from scratch.",
      highlightCards: [
        {
          title: "Zero Base Identity",
          description: "Building visual language entirely from scratch.",
          image: {
            src: "/LatestBuzz/jornie/challenge-zero-base.png",
            alt: "Zero base identity illustration",
          },
        },
        {
          title: "Premium Positioning",
          description: "Balancing simplicity with high-end aesthetics.",
          image: {
            src: "/LatestBuzz/jornie/challenge-premium.png",
            alt: "Premium positioning illustration",
          },
        },
      ],
    },
    approach: [
      "Created moodboards to define the visual direction",
      "Selected color palettes that reflect a premium brand feel",
      "Chose typography that aligns with a modern and clean brand style",
      "Developed multiple design options for posters and creatives",
      "Designed social media grid layouts to maintain consistency",
    ],
    designApproach:
      "We created multiple design variations - exploring posters, palettes, and layouts - and carefully refined them through revisions to align closely with the premium vision.",
    featureBlocks: [
      {
        label: "Poster Style 1",
        image: {
          src: "/LatestBuzz/jornie/design-poster-1.png",
          alt: "Tamil New Year poster style 1",
        },
      },
      {
        label: "Poster Style 2",
        image: {
          src: "/LatestBuzz/jornie/design-poster-2.png",
          alt: "Tamil New Year poster style 2",
        },
      },
    ],
    designExtra: {
      image: {
        src: "/LatestBuzz/jornie/launching-flyer.png",
        alt: "Launching JORNIE Leather Footwears composition",
      },
    },
    outcome: {
      description:
        "A strong, scalable brand identity reflecting the premium quality of the footwear.",
      images: [
        { src: "/LatestBuzz/jornie/outcome-1.png", alt: "JORNIE final outcome - Step Up Your Style Valentine's creative" },
        { src: "/LatestBuzz/jornie/outcome-2.png", alt: "JORNIE final outcome - Posters category collage" },
        { src: "/LatestBuzz/jornie/outcome-3.png", alt: "JORNIE final outcome - Web Banners strip" },
      ],
    },
    testimonial: {
      headline: "Seamless collaboration. Bold vision. Premium results.",
      quote:
        "Working with this team was a seamless and collaborative experience. They gave us the confidence to explore bold ideas and translated our vision into a refined, premium brand identity that truly represents JORNIE.",
      name: "Name",
      role: "Member, Jornie",
      rating: 5,
      logo: {
        src: "/LatestBuzz/jornie/logo.png",
        alt: "JORNIE logo",
      },
    },
  },
];

export default blogPosts;
